
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './routes'
import VueTheMask from 'vue-the-mask'
import VueResource from 'vue-resource'
import ImageUploader from 'vue-image-upload-resize'
import VueToast from 'vue-toast-notification';  
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast, {
  // One of options
  position: 'top-right'
})



Vue.use(ImageUploader)
Vue.use(VueTheMask)
import { store } from './store/store'
import {MediaQueries, CommonBands} from 'vue-media-queries';

const mediaQueries = new MediaQueries({
  bands: CommonBands.Bootstrap4
});
Vue.use(mediaQueries);

Vue.component('pagination', require('laravel-vue-pagination'));

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import money from 'v-money'
import PercentInput from 'vue-percent-input'

// register component <percent-input>
Vue.use(PercentInput)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../src/assets/scss/_main.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './registerServiceWorker'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueRouter)
Vue.use(VueResource)

// register directive v-money and component <money>
Vue.use(money, {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
     })




const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        name: 'login',
      })
    } else {
      next({})
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.isLoggedIn) {
      next({
        name: 'dashboard',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
 router: router,
 store: store,
  render: h => h(App),
  mediaQueries: mediaQueries,
  mixins: [CommonBands.Bootstrap4.mixin],
}).$mount('#app')
